// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metadata_metadata_F_zwu {
  position: absolute;
  bottom: 10px;
  left: 64px;
  font-family: GothamXNarrow-Book;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/metadata.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,eAAe;AACjB","sourcesContent":[".metadata {\n  position: absolute;\n  bottom: 10px;\n  left: 64px;\n  font-family: GothamXNarrow-Book;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"metadata": `metadata_metadata_F_zwu`
};
module.exports = ___CSS_LOADER_EXPORT___;
